import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8 6.5c-.9 0-1.5.6-1.5 1.5S7.1 9.5 8 9.5 9.5 8.9 9.5 8 8.9 6.5 8 6.5m-6.5 0C.6 6.5 0 7.1 0 8s.6 1.5 1.5 1.5S3 8.9 3 8s-.6-1.5-1.5-1.5m13 0c-.9 0-1.5.6-1.5 1.5s.6 1.5 1.5 1.5S16 8.9 16 8s-.6-1.5-1.5-1.5" />
  </svg>
);
const SvgDotDotDot = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="dot-dot-dot" {...props} />;
export default SvgDotDotDot;
